import api from '@shared/api';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import alertsUtil from '@/util/alertsUtil';
import { dialogTypes } from '@/constants/alertTypes';

const restartComputeEngine = async () => {
  const res = await api.get('code-panels/compute/kill');
  return res.data;
};

export const useRestartComputeEngine = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation(restartComputeEngine, {
    onSuccess: async () => {
      await queryClient.invalidateQueries('computeUrl');
    },
    onError: () => {
      dispatch(
        alertsUtil.openErrorDialog(
          dialogTypes.CATCH_ERROR_API,
          'Failed to restart compute engine'
        )
      );
    }
  });
};
